import { render, staticRenderFns } from "./TheLatestDays.vue?vue&type=template&id=996e7224&scoped=true"
import script from "./TheLatestDays.vue?vue&type=script&lang=ts"
export * from "./TheLatestDays.vue?vue&type=script&lang=ts"
import style0 from "./TheLatestDays.vue?vue&type=style&index=0&id=996e7224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996e7224",
  null
  
)

export default component.exports